import React, { useState, forwardRef, useEffect } from "react";
import * as config from "../../../config";
import { useHistory, Link } from "react-router-dom";
import { get } from "lodash";
import { useMsal } from "@azure/msal-react";
import Model from "../../shared/model";
import moment from "moment";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import MaterialTable from "@material-table/core";
import editIcon from "../../../assests/images/editIcon.svg";
import { useTranslation } from "react-i18next";
import { addressSearchStyles } from "./addressStyles";
import { TextField } from "@material-ui/core";
import { DateFormat, DateWithDefaultTime, DateWithEndTime, DateFormatWithoutLocal} from "../../common/utils/DateUtil";
import {
  dateSortFunction,
  sortFunction,
  SortFunctionNew,
} from "../../../Services/util";
import { utils, writeFile } from "xlsx";
import {cloneDeep} from "lodash";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import {
  tableRowFormatter,
  tableRowOrderManager,
} from "../../common/utils/TableUtil";
import excelExport from "../../shared/excelExport.js"
import dateFormatter from "../../shared/dateFormatter.js";
import { USERROLES } from "../../../constants.js";

const AddressListingComponent = (props) => {
  const pathAdminAddressURLs = [
    "/process/shipping",
    "/approveAddress",
    "/approve/materials",
    "/approve/recipients",
    "/materials",
    "/recipients",
    "/shippingRequests",
    "/regulatoryReviewer",
    "/comments",
    "/alerts",
    "/myShippings",
    "/countrycatalouge",
    "/registereduser",
    "/queriesCountry",
    "/queriesCountryTwoWeeks",
    "/myAddress",
    "/my/application/materials",
    "/my/application/recipients",
    "/contact",
    "/phase",
    "/broker",
    "/container",
    "/add-country",
    "/currency",
    "/distributiontemperature",
    "/importerOfRecord",
    "/incoterm",
    "/shippingType",
    "/title",
    "/units",
    "/requestByDelegate",
    "/logistics",
  ];
  const [addressSelected, setAddressSelected] = useState("");
  const { instance } = useMsal();
  const userId = instance.getActiveAccount().username;
  const { listData, actions, searchFilter, setIsLoading, tableAdressOptions } = props;
  const [filteredData, setfilteredData] = useState(listData);
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [isExportModalVisibleSingle, setIsExportModalVisibleSingle] =
    useState(false);
  const [requiredFileName, setrequiredFileName] = useState("");
  const classes = addressSearchStyles();
  const history = useHistory();
  var userType = JSON.parse(localStorage.getItem("userType"));
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  const cardTheme = {
    cardHeaderStylePref: {
      background: "linear-gradient(to right bottom, #D8D8D8, #E0E0E0)",
      color: "#000000",
      height: 30,
      padding: 0,
    },
  };
  useEffect(() => {
    setfilteredData(listData);
  }, [listData]);
  useEffect(() => {
    return () => {
      if (pathAdminAddressURLs.includes(window.location.pathname)) {
       
        actions.setTableOptions({});
        actions.setAddressSearchData({});
      }
    };
  }, []);
  const dispatchAddressAdminOptions = (event, value) => {
    if (event.target === "page") {
      return actions.setTableOptions({
        pageNumber: value.pageNumber,
        pageSize: value.pageSize,
        orderBy: tableAdressOptions.orderBy
      });
    }
    if (event.target === "sort") {
      return actions.setTableOptions({
        pageNumber: 0,
        pageSize: tableAdressOptions.pageSize,
        orderBy: value
      });
    }
  };
  useEffect(() => {
    let validSearchKeys = Object.keys(searchFilter).filter(
      (key) => !!searchFilter[key] && key !== "searchKey",
    );

    const filteredData =
      listData &&
      listData.filter((item) => {
        for (let searchParam of validSearchKeys) {
          if (["submitted", "approved", "valid"].includes(searchParam)) {
            if (item[searchParam] !== 1) {
              return false;
            } else {
              continue;
            }
          }

          if (["startDate", "endDate"].includes(searchParam)) {
            if (searchParam === "startDate") {
              const createDate = moment(item.created_on);
              const startDate = moment(searchFilter[searchParam]);
              if (createDate.isBefore(DateWithDefaultTime(startDate))) {
                return false;
              }
              continue;
            } else {
              const createDate = moment(item.created_on);
              const endDate = moment(searchFilter[searchParam]);
              if (createDate.isAfter(DateWithEndTime(endDate))) {
                return false;
              }
              continue;
            }
          }

          if (
            !item[searchParam] ||
            !item[searchParam]
              .toLowerCase()
              .includes(searchFilter[searchParam].trim().toLowerCase())
          ) {
            return false;
          }
        }
        return true;
      });

    setfilteredData(filteredData);
  }, [searchFilter, listData]);
  const { t, i18n } = useTranslation();
  const handleNewAddress = () => {
    history.push(`/addAddress`);
  };

  const handleCSVExport = async () => {
    let dataForExport = exportDataBuilder();
    let wb = utils.book_new(),
      ws = utils.json_to_sheet(dataForExport);
    utils.book_append_sheet(wb, ws, "Address_Data");
    // writeFile(wb,t("navbar.address") +"_" + DateFormat(date,i18n.resolvedLanguage) + ".xlsx");
    writeFile(wb, requiredFileName + ".xlsx");
  };

  const exportDataBuilder = () => {
    let copyOfFilteredData;
    if (filteredData.length === 0) {
      copyOfFilteredData = cloneDeep(filteredData);
    } else if (filteredData.length > 0) {
      copyOfFilteredData = cloneDeep(filteredData);
    }

  
      //changing column names
      copyOfFilteredData &&
        copyOfFilteredData?.forEach((item) => {
          if (item.created_on) {
            item.created_on = DateFormat(
              item.created_on,
              i18n.resolvedLanguage,
            );
          }
          if (item?.shipment_date_mon) {
            item.shipment_date_mon = DateFormatWithoutLocal(
              item.shipment_date_mon,
              i18n.resolvedLanguage,
            );
          }
          if (item?.shipment_date_lev) {
            item.shipment_date_lev = DateFormatWithoutLocal(
              item.shipment_date_lev,
              i18n.resolvedLanguage,
            );
          }
          if (item.first_name) {
            item.first_name = item.first_name + " " + item.last_name;
          }
       
      item["Company/University"] = item["entity"];
      // item[t("address.Department")] = item["department"];
      item["Building"] = item["building"];
      item["State"] = item["state"];

      item["Street"] = item["street"];
      item["Postal Code"] = item["postcode"];
      item["City"] = item["city"];
      // item[t("address.SAP Number Country")] = item["sapnumber"];
      item["Create Date"] = item["created_on"];
      item["Created User"] = item["created_by"];
      item["Country"] = item["name_english"];
      item["Valid"] = item["valid"];
      item["Approved"] = item["approved"];

      delete item["state"];
      delete item["id"];
      delete item["country_id"];
      delete item["approved"];
      delete item["building"];
      delete item["city"];
      delete item["department"];
      delete item["entity"];
      delete item["postcode"];
      delete item["sapnumber"];
      delete item["street"];
      delete item["submitted"];
      delete item["valid"];
      delete item["created_on"];
      delete item["created_by"];
      delete item["updated_on"];
      delete item["updated_by"];
      delete item["is_active"];
      delete item["name"];
      delete item["name_english"];
      delete item["code"];
      delete item["review_by"];

      for (let key in item) {
        if (item[key] === null) {
          item[key] = "";
        }
      }
    });
    return cloneDeep(copyOfFilteredData);
  };
  const handleInspectAddress = () => {
    if (get(addressSelected, "id", false)) {
      history.push(`/inspectAddress`, { id: get(addressSelected, "id", null) });
      actions.saveTableData(addressSelected);
    }
  };

  const handleApprove = () => {
    let addressData = {};
    addressData = {
      id: addressSelected.id,
      data: 1,
      createdBy: userId,
    };
    setIsLoading(true);
    actions.updateAddressApproval(addressData).then(() => {
      setfilteredData([]);
      setAddressSelected("");
      actions.getAllAddress().then(() => {
        setIsLoading(false);
      });
    });
  };
  const ExportBtn = () => {
    return (
      <button
        className="mr-1"
        onClick={() => {
          setIsExportModalVisible(true);
        }}
      >
        {t("export.exportall")}
      </button>
    );
  };

  const handleActivate = () => {
    let addressData = {};
    if (get(addressSelected, "valid", 0) === 1) {
      addressData = {
        id: addressSelected.id,
        data: 0,
      };
    } else {
      addressData = {
        id: addressSelected.id,
        data: 1,
      };
    }
    setIsLoading(true);
    actions.updateAddressAccess(addressData).then(() => {
      setfilteredData([]);
      setAddressSelected("");
      actions.getAllAddress().then(() => {
        setIsLoading(false);
      });
    });
  };
  const handleRadiobuttonChange = (data) => {
    setAddressSelected(data);
  };
 
  const ExportSelectedBtn = () => {
    let excelDataProperty = [
      { "displayName": "Company/University", "dbColumn": "entity", "width": 25 },
      { "displayName": "Department", "dbColumn": "department", "width": 25 },
      { "displayName": "Building", "dbColumn": "building", "width": 10 },
      { "displayName": "Street", "dbColumn": "street", "width": 10 },
      { "displayName": "Postal Code", "dbColumn": "postcode", "width": 10 },
      { "displayName": "City", "dbColumn": "city", "width": 10 },
      { "displayName": "State", "dbColumn": "state", "width": 20 },
      { "displayName": "Country", "dbColumn": "name_english", "width": 10 },
      { "displayName": "Created By", "dbColumn": "created_by", "width": 50 },
      { "displayName": "Create On", "dbColumn": "created_on", "width": 15 },
      { "displayName": "Updated By", "dbColumn": "updated_by", "width": 50 },
      { "displayName": "Updated On", "dbColumn": "updated_on", "width": 15 },
      { "displayName": "Valid", "dbColumn": "valid", "width": 10 },
    ];

    actions.getSelectedAddressData(addressSelected.id).then((response) => {
        let dataForExport = [];
        dataForExport.push(response.data[0]);
        dataForExport = dateFormatter.formateDateField(dataForExport);
        excelExport.exportAllData(excelDataProperty, dataForExport, "Address_Data", requiredFileName);
    });
  };
  const ExportSelectedBtnForSingle = () => {
    return (
      <button
        disabled={addressSelected === "" ? true : false}
        onClick={(e) => {
          setIsExportModalVisibleSingle(true);
        }}
      >
        {t("export.exportselected")}
      </button>
    );
  };
  const exportModalBody = () => {
    return (
      <div className="row  m0">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="col-form-label">
                  {t("exportLabel.fileName")}:
                </label>
                &nbsp;
                <input
                  type="text"
                  className="form-control custom-form-control"
                  value={requiredFileName}
                  onChange={(e) => {
                    setrequiredFileName(e.target.value);
                  }}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const exportModalFooter = () => {
    return (
      <>
        <button
          type="button"
          id="Yes"
          disabled={requiredFileName.trim() != "" ? false : true}
          className="btn btn-primary btn-inner-close"
          onClick={(e) => {
            handleCSVExport();
            setIsExportModalVisible(false);
            setrequiredFileName("");
          }}
        >
          {t("export.export")}
        </button>

        <button
          type="button"
          id="Close"
          //disabled={isModalSaveRunning}
          className="btn btn-black btn-inner-close cancel_button"
          onClick={(e) => {
            setIsExportModalVisible(false);
            setrequiredFileName("");
          }}
        >
          Cancel
        </button>
      </>
    );
  };
  const exportModalBodySingleData = () => {
    return (
      <div className="row  m0">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="col-form-label">
                  {t("exportLabel.fileName")}:
                </label>
                &nbsp;
                <input
                  type="text"
                  className="form-control custom-form-control"
                  value={requiredFileName}
                  onChange={(e) => {
                    setrequiredFileName(e.target.value);
                  }}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const exportModalFooterSingleData = () => {
    return (
      <>
        <button
          type="button"
          id="Yes"
          disabled={requiredFileName.trim() != "" ? false : true}
          className="btn btn-primary btn-inner-close"
          onClick={(e) => {
            ExportSelectedBtn();
            setIsExportModalVisibleSingle(false);
            setrequiredFileName("");
          }}
        >
          {t("export.export")}
        </button>
        <button
          type="button"
          id="Close"
          //disabled={isModalSaveRunning}
          className="btn btn-black btn-inner-close cancel_button"
          onClick={(e) => {
            setIsExportModalVisibleSingle(false);
            setrequiredFileName("");
          }}
        >
          Cancel
        </button>
      </>
    );
  };
  return (
    <>
      <div className="row m0 no_padding container-fluid ">
        <div className="no_padding col-12 mt-3 mb-2 d-flex justify-content-end">
          {userType.includes(USERROLES.SYSTEMADMINISTRATOR) === true || userType.includes(USERROLES.ADMIN) === true ? (
          <div className="buttonsec_animalmanagment">
            <DropdownButton
              title={t("export.export")}
              className="mr-1 exportdropdown"
            >
              <Dropdown.Item>{ExportBtn()}</Dropdown.Item>
              <Dropdown.Item>{ExportSelectedBtnForSingle()}</Dropdown.Item>
            </DropdownButton>

            {/* <button
              className="btn btn-primary btn-inner-close new_button mr-1"
               disabled={get(addressSelected, "id", 0) === 0 ? true : false}
              onClick={() => {
                ;
             
         
              }}
            >
              {t("shippingrequest.export")+ " " + "Selected Data"}
            </button> */}
            <button
              className="btn btn-primary btn-inner-close new_button mr-1"
              disabled={get(addressSelected, "id", 0) === 0 ? true : false}
              onClick={() => handleInspectAddress()}
            >
              {t("address.inspect")}
            </button>
            <button
              className="btn btn-primary btn-inner-close new_button mr-1"
              onClick={() => handleNewAddress()}
            >
              {t("address.new")}
            </button>
            <button
              className="btn btn-inner-approve   new_button mr-1"
              onClick={() => handleApprove()}
              disabled={get(addressSelected, "id", 0) === 0 ? true : get(addressSelected, "approved", 0) === 1 ? true : false}
            >
              {t("address.approve")}
            </button>
            <button
              className="btn btn-inner-approve   new_button "
              onClick={() => handleActivate()}
              disabled={get(addressSelected, "id", 0) === 0 ? true : false}
            >
              {get(addressSelected, "valid", 0) === 1
                ? t("address.deactivate")
                : t("address.activate")}
            </button>
            {/* <TextField size="small" placeholder="Search" /> */}
          </div>
          ):(<button
              className="btn btn-primary btn-inner-close new_button mr-1"
              disabled={get(addressSelected, "id", 0) === 0 ? true : false}
              onClick={() => handleInspectAddress()}
            >
              {t("address.inspect")}
            </button>
          )}
        </div>
      </div>
      <Card variant="outlined">
        <CardHeader
          className="searchresult_header"
          title={t("phase.searchresults")}
        />
        <Divider />
        <CardContent>
          <div style={{ paddingBottom: "2%" }}>
              <MaterialTable
                onPageChange={(page, itemsPerPage) => {
                  dispatchAddressAdminOptions({ target: "page" }, { "pageNumber": page, "pageSize": itemsPerPage });
                }}
                onOrderCollectionChange={(orderBy) => {
                  dispatchAddressAdminOptions({ target: "sort" }, orderBy);
                }}
                columns={[
                  {
                    width: "15%",
                    sorting: false,
                    render: (rowData) => (
                      <input
                        type="radio"
                        value={get(addressSelected, "id", "")}
                        name="radiovalues"
                        className={classes.tableRadio}
                        onChange={(e) => handleRadiobuttonChange(rowData)}
                      />
                    ),
                  },
                  {
                    title: <span>{t("address.Company/University")}</span>,
                    field: "entity",
                    customSort: (a, b) => {
                      if (
                        a.entity.toString().toLowerCase() >
                        b.entity.toString().toLowerCase()
                      ) {
                        return -1;
                      } else if (
                        a.entity.toString().toLowerCase() <
                        b.entity.toString().toLowerCase()
                      ) {
                        return 1;
                      } else {
                        return 0;
                      }
                    },
                  },

                  // {
                  //   title: <span>{t("address.Department")}</span>,
                  //   field: "department",
                  //   customSort: SortFunctionNew("department"),
                  // },
                  {
                    title: <span>{t("address.building")}</span>,
                    field: "building",
                    customSort: SortFunctionNew("building"),
                  },
                  {
                    title: <span>{t("address.City")}</span>,
                    field: "city",
                    customSort: SortFunctionNew("city"),
                  },
                  {
                    title: <span>{t("address.State")}</span>,
                    field: "state",
                    customSort: SortFunctionNew("state"),
                  },
                  {
                    title: <span>{t("address.Postal Code")}</span>,
                    field: "postcode",
                    customSort: SortFunctionNew("postcode"),
                  },
                  {
                    title: <span>{t("address.Street")}</span>,
                    field: "street",
                    customSort: SortFunctionNew("street"),
                  },

                  {
                    title: <span>{t("address.Country")}</span>,
                    field: "name_english",
                    customSort: (a, b) => {
                      if (
                        (a.name_english + a.code).toString().toLowerCase() >
                        (b.name_english + b.code).toString().toLowerCase()
                      ) {
                        return -1;
                      } else if (
                        (a.name_english + a.code).toString().toLowerCase() <
                        (b.name_english + b.code).toString().toLowerCase()
                      ) {
                        return 1;
                      } else {
                        return 0;
                      }
                    },
                    render: (rowData) => (<span style={{color:(rowData?.countryvalid == false)?'orange':''}}>
                      {rowData.name_english}
                    </span>),
                  },
                  // {
                  //   title: <span>{t("address.SAP Number Country")}</span>,
                  //   field: "sapnumber",
                  // },
                  {
                    title: <span>{t("address.Create Date")}</span>,
                    customSort: dateSortFunction("created_on"),
                    render: (rowData) => DateFormat(rowData.created_on,i18n.resolvedLanguage),
                  },
                  {
                    title: <span>{t("address.Created User")}</span>,
                    field: "created_by",
                    customSort: SortFunctionNew("created_by"),
                  },
                  {
                    title: <span>{t("address.Approved")}</span>,
                    customSort: (a, b) => {
                      if (a.approved > b.approved) {
                        return -1;
                      } else if (a.approved < b.approved) {
                        return 1;
                      } else if (a.approved === b.approved) {
                        return 0;
                      } else {
                        return 0;
                      }
                    },
                    render: (rowData) =>
                      rowData.approved === 1 ? (
                        <span>
                          <div>
                            <input
                              type="checkbox"
                              defaultChecked={true}
                              disabled
                            />
                          </div>
                        </span>
                      ) : (
                        <div>
                          <span>
                            <div>
                              <input
                                type="checkbox"
                                defaultChecked={false}
                                disabled
                              />
                            </div>
                          </span>
                        </div>
                      ),
                  },
                  {
                    title: <span>{t("address.Valid")}</span>,
                    customSort: (a, b) => {
                      if (a.valid > b.valid) {
                        return -1;
                      } else if (a.valid < b.valid) {
                        return 1;
                      } else if (a.valid === b.valid) {
                        return 0;
                      } else {
                        return 0;
                      }
                    },
                    render: (rowData) =>
                      rowData.valid === 1 ? (
                        <span>
                          <div>
                            <input
                              type="checkbox"
                              defaultChecked={true}
                              disabled
                            />
                          </div>
                        </span>
                      ) : (
                        <div>
                          <span>
                            <div>
                              <input
                                type="checkbox"
                                defaultChecked={false}
                                disabled
                              />
                            </div>
                          </span>
                        </div>
                      ),
                  },
                  {
                    title: <span></span>,
                    sorting: false,
                    render: (rowData) => (
                       userType.includes(USERROLES.SYSTEMADMINISTRATOR) === true || userType.includes(USERROLES.ADMIN) === true ? (
                      <Link
                        to={{
                          pathname: `/addAddress`,
                          state: { id: rowData.id},
                        }}
                        className={classes.accordionLink}
                        onClick={() => actions.saveTableData(rowData)}
                      >
                        <img alt="t" className="iconsize" src={editIcon}></img>
                      </Link>
                       ):<span></span>
                    ),
                  },
                ]}
                data={filteredData}
                title="Render Image Preview"
                localization={{
                  pagination: {
                    labelRowsSelect: t("commonlabels.labelRowsSelect"),
                    firstAriaLabel: t("commonlabels.firstAriaLabel"),
                    firstTooltip: t("commonlabels.firstTooltip"),
                    previousAriaLabel: t("commonlabels.previousAriaLabel"),
                    previousTooltip: t("commonlabels.previousTooltip"),
                    nextAriaLabel: t("commonlabels.nextAriaLabel"),
                    nextTooltip: t("commonlabels.nextTooltip"),
                    lastAriaLabel: t("commonlabels.lastAriaLabel"),
                    lastTooltip: t("commonlabels.lastTooltip"),
                  },
                  body: {
                    emptyDataSourceMessage: t(
                      "commonlabels.emptyDataSourceMessage",
                    ),
                  },
                }}
                icons={tableIcons}
                options={{
                  draggable: false,
                  thirdSortClick: false,
                  //  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: "#cce3f5",
                    fontWeight: "bold",
                    height: "10px",
                  },
                  rowStyle: tableRowFormatter({
                    height: "30px",
                    padding: "0px",
                  }),
                  initialPage: parseInt(tableAdressOptions?.pageNumber ? tableAdressOptions?.pageNumber : 0),
                  sortIcon: true,
                  maxBodyHeight: "90%",
                  tableLayout: "auto",
                  sorting: true,
                  search: false,
                  selection: false,
                  showTitle: false,
                  toolbar: false,
                  paging: true,
                  paginationType: "stepped",
                  pageSize: parseInt(tableAdressOptions?.pageSize ? tableAdressOptions?.pageSize : 10),
                  defaultOrderByCollection: tableAdressOptions?.orderBy ? tableAdressOptions?.orderBy : "",
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                  showSelectAllCheckbox: false,
                }}
              />
          </div>
        </CardContent>
      </Card>
      <Model
        showheader={isExportModalVisible}
        modalHeader={t("exportLabel.title")}
        modalbody={exportModalBody()}
        modalfooter={exportModalFooter()}
      ></Model>
      <Model
        showheader={isExportModalVisibleSingle}
        modalHeader={t("exportLabel.title")}
        modalbody={exportModalBodySingleData()}
        modalfooter={exportModalFooterSingleData()}
      ></Model>
    </>
  );
};

export default AddressListingComponent;
